import PropTypes from 'prop-types';
import ImageWithDefault from 'src/common/components/shared/ImageWithDefault';
import css from './team-logos.module.scss';

const TeamLogos = ({ gameInfo }) => (
  <div className={css.container}>
    <ImageWithDefault
      dataTestId="teamLogo1"
      className={css.imgThumbnail}
      src={gameInfo.firstTeamLogoUrl}
      alt="team logo 1"
    />
    <div className={css.separator}>
      <p className={css.vs}>{gameInfo.teamsSeparator}</p>
    </div>
    <ImageWithDefault
      dataTestId="teamLogo2"
      className={css.imgThumbnail}
      src={gameInfo.secondTeamLogoUrl}
      alt="team logo 2"
    />
  </div>
);

TeamLogos.propTypes = {
  gameInfo: PropTypes.object.isRequired,
};

export default TeamLogos;
